import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  REPORTS_BASE_URL,
  TOP_SALLER_REPORT_FACT_API,
} from "../../../Constants/Config";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";

const initialState = {
  loading: false,
  topsallerData: [],
  status: false,
  successMessage: "",
  error: "",
};

let cancelTokenSource;

// Generate pening , fulfilled and rejected action type
export const fetchtopsallerData = createAsyncThunk(
  "dailyreport/fetchtopsallerData.",
  async (data, { rejectWithValue }) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }

    // Create a new cancel token
    cancelTokenSource = axios.CancelToken.source();
    try {
      const { token, ...dataNew } = data;

      // The fact endpoint is FastAPI and reads Form() fields, so the body must
      // be a real multipart FormData. Posting a plain object with a hand-set
      // "Content-Type: multipart/form-data" (what this did against PHP) sends
      // JSON with no multipart boundary, which FastAPI parses as zero fields.
      // The header is omitted so axios can generate the boundary itself.
      const formData = new FormData();
      const append = (key, value) => {
        if (value === undefined || value === null || value === "") return;
        formData.append(key, value);
      };

      append("merchant_id", dataNew?.merchant_id);
      // DashDateRangeComponent's Outlet picker is already multi-select and
      // emits `stores` as a comma-joined merchant_id list; that IS the
      // multi-location filter. Fall back to the logged-in merchant so a
      // single-store login stays scoped rather than widening to everything.
      append(
        "outlet_ids",
        dataNew?.outlet_ids || dataNew?.stores || dataNew?.merchant_id
      );
      append("start_date", dataNew?.start_date);
      append("end_date", dataNew?.end_date);
      append("limit", dataNew?.limit);
      append("category_id", dataNew?.category_id || "all");
      append("order_env", dataNew?.order_env);
      append("token_id", dataNew?.token_id);
      append("login_type", dataNew?.login_type);
      append("session_id", dataNew?.session_id);

      const response = await axios.post(
        REPORTS_BASE_URL + TOP_SALLER_REPORT_FACT_API,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource.token,
        }
      );
      if (response.data.status === "Success") {
        const arr = response.data.result;
        const status = response.data.status;
        return { arr, status };
      } else if (
        response.data.status === "Failed" &&
        response.data.msg === "No. Data found."
      ) {
        const arr = [];
        const status = false;
        return { arr, status };
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
// Generate pening , fulfilled and rejected action type

const topsallerSlice = createSlice({
  name: "topsaller",
  initialState,
  reducers: {
    updateStateOfTopSeller: (state) => {
      state.topsallerData = [];
    },
    updateStateOfTopSellerStatus: (state) => {
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchtopsallerData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchtopsallerData.fulfilled, (state, action) => {
      state.loading = false;
      state.topsallerData = action.payload.arr;
      state.status = action.payload.status;
      state.error = "";
    });
    builder.addCase(fetchtopsallerData.rejected, (state, action) => {
      state.loading = false;
      state.topsallerData = {};
      state.error = action.error.message;
    });
  },
});

export const { updateStateOfTopSeller, updateStateOfTopSellerStatus } =
  topsallerSlice.actions;
export default topsallerSlice.reducer;
